/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetTeam } from './team.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetTeams = {
  id: 'teams.get',
  tag: 'Team',
  summary: 'Get organization teams',
  description: 'Retrieve all teams within an organization',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/team`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: { 'application/json': { schema: z.array(GetTeam.response['200'].content['application/json'].schema) } },
    },
  },
} as const satisfies Endpoint;
